import React, { useState } from "react";
import Back from "../Back";
import ScrollToTop from "../ScrollToTop";
import {
    AgendaContainer,
    AgendaTitle,
    AgendaWrap,
    AgendaTabRow,
    AgendaTabButton,
    AgendaEvents,
    AgendaEvent,
    AgendaTime,
    AgendaEventDescription,
    AgendaSpeakerWrap,
    AgendaSpeakerUl,
    AgendaSpeakerLi
} from "./AgendaElements";
import { DiNetbeans } from "react-icons/di";

const Agenda = () => {
    const agenda = require("./programa.json")



    const [day, setDay] = useState(agenda[0]);
    const [jueves, setJueves] = useState("true");
    const [viernes, setViernes] = useState("false");

   

    return (
        <>
            <ScrollToTop />
            <Back />
            <AgendaContainer>
                <AgendaTitle>PROGRAMA - DIC. 01-02</AgendaTitle>
                <AgendaWrap>
                    <AgendaTabRow>
                        <AgendaTabButton
                            onClick={() => {
                                setDay(agenda[0]);
                                setJueves("true");
                                setViernes("false")
                            }}
                            jueves={jueves}
                        >
                            JUEVES 01
                        </AgendaTabButton>
                        <AgendaTabButton
                            onClick={() => {
                                setDay(agenda[1]);
                                setJueves("false");
                                setViernes("true")
                            }}
                            viernes={viernes}
                        >
                            VIERNES 02
                        </AgendaTabButton>
                    </AgendaTabRow>
                    <AgendaEvents>
                        {day.map((e, index) => {
                            return (
                                <AgendaEvent key={index}>
                                    <AgendaTime> {e.hora} </AgendaTime>
                                    <AgendaEventDescription>
                                        {e.evento}
                                    </AgendaEventDescription>
                                    <AgendaSpeakerWrap>
                                        <AgendaSpeakerUl>
                                            {e.speakers &&
                                                e.speakers.map((s, index) => (
                                                    <AgendaSpeakerLi key={index}> <DiNetbeans /> {s} </AgendaSpeakerLi>
                                                ))}
                                        </AgendaSpeakerUl>
                                    </AgendaSpeakerWrap>
                                </AgendaEvent>
                            );
                        })}
                    </AgendaEvents>
                </AgendaWrap>
            </AgendaContainer>
        </>
    );
};

export default Agenda;
